// extracted by mini-css-extract-plugin
export var legendIndicator = "_dy-1";
export var legendRight = "_dy-0";